/* @ngInject */
function run ($rootScope, $http, $location, $state) {
  $rootScope.$on('$stateChangeStart', (event, state) => {
    const isGuestAllowed = state.name === 'inactive' || state.name === 'blockLogins' // blockLogins = /unauthorized
    const isAuthorized = $http.defaults.headers.common.Authorization
    const isGuestState = state.name.startsWith('guest') || state.name.startsWith('assetPack')
    const isGuestPublicState = state.name === 'guest.login' || state.name === 'guest.resendPassword'
    const isGuestAssetPackViews = state.name === 'assetPack.assetPackSummary' ||
      state.name === 'assetPack.assetPackFolder' ||
      state.name === 'assetPack.assetPackDownloadAll'
    const isNotLoginState = state.name !== 'login'

    if (isGuestAllowed) {
      return
    }
    if (isAuthorized) {
      // Ensures the user exists when calling isGuest.
      $rootScope.getUser().then((user) => {
        const isGuest = $rootScope.isGuest(user)
        if (!isGuest && (isGuestPublicState || isGuestAssetPackViews)) {
          return
        }

        if (!isGuest && isGuestState) {
          const url = $location.url()

          $location
            .path('/guest/login')
            .search({
              next: url
            })
        } else if (isGuest && !isGuestState && isNotLoginState) {
          $state.go('guest.home')
        }
      })
    }
  })
}
export const guestRun = run
